module.exports = __webpack_public_path__ + "img/logo_formate.308dac4e.svg";